export default "__VITE_ASSET__DuwWVOnw__"